import {get} from "@/context/context";
import {TeacherRepository} from "@/repositories/TeacherRepository";
import {RequestConfig} from "@/models/RequestConfig";
import API from "@/utils/Api";
import {Teacher} from "@/models/Teacher/Teacher";
import {TeacherRequest} from "@/models/Teacher/TeacherRequest";
import {Servers} from "@/serverConfig";

export class TeacherService {

    public teacherRepository: TeacherRepository = get('teacherRepository');
    private api: API = get('api');

    public async getList(): Promise<Teacher[]> {
        this.api.changeServer(Servers.BACK);
        return await this.teacherRepository.getList();
    }

    public async getListByStyle(styleId:string): Promise<Teacher[]> {
        this.api.changeServer(Servers.BACK);
        return await this.teacherRepository.getListByStyle(styleId);
    }

    public async create(payload: TeacherRequest, config?:RequestConfig): Promise<Teacher> {
        this.api.changeServer(Servers.BACK);
        return await this.teacherRepository.create(payload, config);
    }

    public async edit(payload: TeacherRequest, config?:RequestConfig): Promise<Teacher> {
        this.api.changeServer(Servers.BACK);
        return await this.teacherRepository.edit(payload, config);
    }

    public async delete(id: string): Promise<void> {
        this.api.changeServer(Servers.BACK);
        return await this.teacherRepository.delete(id);
    }
}
